const axisPointerTimeFormatter = new Intl.DateTimeFormat("en-US", {
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
});

const tooltipValueFormatter = new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 });

/**
 * Format a timestamp for the x-axis crosshair badge — "Aug 5 5:32 am".
 * Intl includes a comma and uppercases AM/PM; strip both so the badge stays compact.
 */
export function formatAxisPointerTime(value: number | string | Date): string {
    const date = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(date.getTime())) return String(value);

    return axisPointerTimeFormatter
        .format(date)
        .replace(",", "")
        .replace(/\s(AM|PM)$/i, (_, period: string) => ` ${period.toLowerCase()}`);
}

/** Format a numeric value for tooltip display — at most 2 decimal places, no float noise. */
export function formatTooltipValue(value: number): string {
    return tooltipValueFormatter.format(value);
}
